import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Check, Sparkles, Palette, MessageSquare } from 'lucide-react';
export function Pricing() {
  return <Layout data-id="element-651">
      <div className="py-20 bg-gray-50 min-h-screen" data-id="element-652">
        <div className="container mx-auto px-4" data-id="element-653">
          <div className="text-center mb-16" data-id="element-654">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-655">
              Simple Pricing
            </h1>
            <p className="text-xl text-muted-foreground" data-id="element-656">
              No trial. Cancel anytime.
            </p>
          </div>

          {/* Main Plans */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-20" data-id="element-657">
            {/* Free Tier */}
            <Card className="p-8 flex flex-col" data-id="element-658">
              <div className="mb-8" data-id="element-659">
                <h3 className="text-2xl font-bold mb-2" data-id="element-660">Free</h3>
                <div className="text-4xl font-bold" data-id="element-661">£0</div>
                <p className="text-muted-foreground mt-2" data-id="element-662">
                  Perfect for your first experiment.
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-663">
                <li className="flex items-center gap-3" data-id="element-664">
                  <Check className="w-5 h-5 text-green-500" data-id="element-665" />
                  <span data-id="element-666">1 Active FlingLink</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-667">
                  <Check className="w-5 h-5 text-green-500" data-id="element-668" />
                  <span data-id="element-669">Full 7-day cycle</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-670">
                  <Check className="w-5 h-5 text-green-500" data-id="element-671" />
                  <span data-id="element-672">Basic Recap Card</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-673">
                  <Check className="w-5 h-5 text-green-500" data-id="element-674" />
                  <span data-id="element-675">Soft Launch Mode</span>
                </li>
              </ul>

              <a href="https://me.flinglink.app/signup" className="w-full" data-id="element-676">
                <Button className="w-full" variant="outline" data-id="element-677">
                  Get Your FlingLink
                </Button>
              </a>
            </Card>

            {/* Plus Experience - One-off */}
            <Card className="p-8 flex flex-col border-2 border-purple-200" data-id="element-678">
              <div className="absolute top-0 right-0 text-white text-xs font-bold px-3 py-1 rounded-bl-xl" style={{
              backgroundColor: '#9333ea'
            }} data-id="element-679">
                ONE-OFF
              </div>

              <div className="mb-8" data-id="element-680">
                <h3 className="text-2xl font-bold mb-2" style={{
                color: '#9333ea'
              }} data-id="element-681">
                  Plus Experience
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-682">
                  <span className="text-4xl font-bold" data-id="element-683">£2</span>
                  <span className="text-muted-foreground" data-id="element-684">/7 days</span>
                </div>
                <p className="text-muted-foreground mt-2" data-id="element-685">
                  Try Plus features for one Fling.
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-686">
                <li className="flex items-center gap-3" data-id="element-687">
                  <Check className="w-5 h-5" style={{
                  color: '#9333ea'
                }} data-id="element-688" />
                  <span className="font-medium" data-id="element-689">All Plus features</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-690">
                  <Check className="w-5 h-5" style={{
                  color: '#9333ea'
                }} data-id="element-691" />
                  <span data-id="element-692">Premium Question Decks</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-693">
                  <Check className="w-5 h-5" style={{
                  color: '#9333ea'
                }} data-id="element-694" />
                  <span data-id="element-695">Custom Recap Themes</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-696">
                  <Check className="w-5 h-5" style={{
                  color: '#9333ea'
                }} data-id="element-697" />
                  <span data-id="element-698">Valid for 7 days only</span>
                </li>
              </ul>

              <a href="https://me.flinglink.app/signup" className="w-full" data-id="element-699">
                <Button className="w-full" style={{
                backgroundColor: '#9333ea'
              }} data-id="element-700">
                  Try Plus Experience
                </Button>
              </a>
            </Card>

            {/* Plus Tier */}
            <Card className="p-8 shadow-xl relative overflow-hidden flex flex-col" style={{
            borderColor: '#ff6b6b',
            borderWidth: '2px'
          }} data-id="element-701">
              <div className="absolute top-0 right-0 text-white text-xs font-bold px-3 py-1 rounded-bl-xl" style={{
              backgroundColor: '#ff6b6b'
            }} data-id="element-702">
                MOST POPULAR
              </div>

              <div className="mb-8" data-id="element-703">
                <h3 className="text-2xl font-bold mb-2" style={{
                color: '#ff6b6b'
              }} data-id="element-704">
                  Plus
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-705">
                  <span className="text-4xl font-bold" data-id="element-706">£6.99</span>
                  <span className="text-muted-foreground" data-id="element-707">/mo</span>
                </div>
                <p className="text-muted-foreground mt-2" data-id="element-708">
                  For the serial dater (we don't judge).
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-709">
                <li className="flex items-center gap-3" data-id="element-710">
                  <Check className="w-5 h-5" style={{
                  color: '#ff6b6b'
                }} data-id="element-711" />
                  <span className="font-medium" data-id="element-712">10 Active Flings</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-713">
                  <Check className="w-5 h-5" style={{
                  color: '#ff6b6b'
                }} data-id="element-714" />
                  <span className="font-medium" data-id="element-715">Unlimited Renewals</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-716">
                  <Check className="w-5 h-5" style={{
                  color: '#ff6b6b'
                }} data-id="element-717" />
                  <span data-id="element-718">Premium Question Decks</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-719">
                  <Check className="w-5 h-5" style={{
                  color: '#ff6b6b'
                }} data-id="element-720" />
                  <span data-id="element-721">Custom Recap Themes</span>
                </li>
              </ul>

              <a href="https://me.flinglink.app/settings/upgrade" className="w-full" data-id="element-722">
                <Button className="w-full" variant="primary" style={{
                backgroundColor: '#ff6b6b'
              }} data-id="element-723">
                  Get Plus
                </Button>
              </a>
              <p className="text-xs text-center text-muted-foreground mt-4" data-id="element-724">
                or £59.99/year (save 30%)
              </p>
            </Card>
          </div>

          {/* Optional Add-ons */}
          <div className="max-w-4xl mx-auto" data-id="element-725">
            <div className="text-center mb-10" data-id="element-726">
              <h2 className="text-3xl font-bold mb-4" data-id="element-727">Optional Add-ons</h2>
              <p className="text-muted-foreground" data-id="element-728">
                Want upgrades without Plus? No subscription required.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-729">
              <Card className="p-6 hover:shadow-md transition-shadow" data-id="element-730">
                <div className="w-12 h-12 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-600 mb-4" data-id="element-731">
                  <Sparkles className="w-6 h-6" data-id="element-732" />
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-733">Spark Deck Packs</h3>
                <p className="text-2xl font-bold mb-4" data-id="element-734">
                  £2.99{' '}
                  <span className="text-sm font-normal text-muted-foreground" data-id="element-735">
                    each
                  </span>
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-736">
                  Unlock themed question packs like "Deep Talk", "Spicy", or
                  "Future Planning".
                </p>
              </Card>

              <Card className="p-6 hover:shadow-md transition-shadow" data-id="element-737">
                <div className="w-12 h-12 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 mb-4" data-id="element-738">
                  <Palette className="w-6 h-6" data-id="element-739" />
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-740">Recap Theme Packs</h3>
                <p className="text-2xl font-bold mb-4" data-id="element-741">
                  £1.99{' '}
                  <span className="text-sm font-normal text-muted-foreground" data-id="element-742">
                    each
                  </span>
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-743">
                  Customize your weekly recap with exclusive colors, patterns,
                  and layouts.
                </p>
              </Card>

              <Card className="p-6 hover:shadow-md transition-shadow" data-id="element-744">
                <div className="w-12 h-12 rounded-full bg-green-100 flex items-center justify-center text-green-600 mb-4" data-id="element-745">
                  <MessageSquare className="w-6 h-6" data-id="element-746" />
                </div>
                <h3 className="text-lg font-bold mb-2" data-id="element-747">SMS Fling Reminders</h3>
                <p className="text-2xl font-bold mb-4" data-id="element-748">
                  £1.99{' '}
                  <span className="text-sm font-normal text-muted-foreground" data-id="element-749">
                    /mo
                  </span>
                </p>
                <p className="text-sm text-muted-foreground" data-id="element-750">
                  Get daily nudges via SMS so you never break a streak. (Opt-in
                  only).
                </p>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </Layout>;
}